import { getI18nLanguageFromLocalStorage } from '../helpers/localStorageHelper';

export function getCountryName(countryCode) {
    const locals = getI18nLanguageFromLocalStorage();
    const regionNames = new Intl.DisplayNames([locals ?? 'en'], { type: "region" });
    return regionNames.of(countryCode.toUpperCase());
}

export function getLanguageName(languagesCode) {
    const locals = getI18nLanguageFromLocalStorage();
    const languages = new Intl.DisplayNames([locals], { type: "language" });
    return languages.of(languagesCode.toUpperCase());
}